import React from "react";

export const TableLoaderRow = ({ colSpan = 6, message = "Loading data..." }) => (
  <tr className="qx-table-loader-row">
    <td colSpan={colSpan} className="qx-table-loader-cell">
      <div className="qx-table-loader" role="status" aria-live="polite">
        <span className="qx-table-loader-spinner" aria-hidden="true" />
        <span className="qx-table-loader-text">{message}</span>
      </div>
    </td>
  </tr>
);

export const TableEmptyRow = ({ colSpan = 6, message = "No data found" }) => (
  <tr className="qx-table-empty-row">
    <td colSpan={colSpan} className="qx-table-empty-cell">
      <div className="qx-table-empty">
        <p className="qx-table-empty__title mb-1">{message}</p>
        <p className="qx-table-empty__desc mb-0">Try adjusting your search or check back later.</p>
      </div>
    </td>
  </tr>
);

export const PageContentLoader = ({ message = "Loading..." }) => (
  <div className="qx-page-loader" role="status" aria-live="polite">
    <span className="qx-table-loader-spinner qx-table-loader-spinner--lg" aria-hidden="true" />
    <span className="qx-table-loader-text">{message}</span>
  </div>
);

export default PageContentLoader;
